import EDBox from '../../../../../../../../../../BaseComponents/EDBox/EDBox';
import EDTypography from '../../../../../../../../../../BaseComponents/Typography/EDTypography';
import EDIcon, {
  IconVerticalAlign,
} from '../../../../../../../../../../BaseComponents/Icon/EDIcon';
import { IconType } from '../../../../../../../../../../BaseComponents/Icon/Utils/IconDefinitions';

interface IProps {
  labelText: string;
  subLabelText?: string;
  iconType?: IconType;
  iconVerticalAlign?: IconVerticalAlign;
}

const EkonomiskAnalysExpansionLabel: React.FC<IProps> = ({
  labelText,
  subLabelText,
  iconType,
  iconVerticalAlign,
}) => {
  return (
    <EDBox
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        width: 'fit-content',
        margin: '0 auto',
        minWidth: 0,
      }}
    >
      {iconType && (
        <EDIcon
          iconType={iconType}
          size="default"
          color="primary"
          verticalAlign={iconVerticalAlign}
        />
      )}
      <EDTypography
        variant="subtitle1"
        sx={{
          fontWeight: 600,
          fontSize: '20px',
          lineHeight: 1.2,
          letterSpacing: '0.01em',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}
      >
        {labelText}
      </EDTypography>
      {subLabelText && (
        <EDTypography
          variant="body2"
          sx={theme => ({
            color: theme.palette.text.secondary,
            fontWeight: 400,
            lineHeight: 1.2,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            '&::before': {
              content: '"·"',
              display: 'inline-block',
              marginRight: theme.spacing(1),
              opacity: 0.6,
            },
          })}
        >
          {subLabelText}
        </EDTypography>
      )}
    </EDBox>
  );
};

export default EkonomiskAnalysExpansionLabel;
